'use client'

export default function NotFound() {
  return (
    <div>
      <h1>Ups - ein Fehler</h1>
    </div>
  )
}
